import { reactive, readonly } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export const OPEN_DATA_PARTNERS_LIST_ROUTE: RouteLocationRaw = {
  name: 'partners',
  query: { tab: 'offline', sortBy: 'createdAt__desc__raw' },
};

type OpenDataPartnerPreparingState = {
  isVisible: boolean;
  count: number;
  partnerOrgId: number | null;
};

const state = reactive<OpenDataPartnerPreparingState>({
  isVisible: false,
  count: 0,
  partnerOrgId: null,
});

/* Kept outside the reactive state so readonly() never has to wrap a thenable. */
let pendingRefresh: Promise<unknown> | null = null;

export function useOpenDataPartnerPreparing() {
  function showOpenDataPartnersPreparing(options: {
    count: number;
    partnerOrgId?: number | null;
    refreshPromise?: Promise<unknown> | null;
  }) {
    state.count = options.count;
    state.partnerOrgId =
      options.count === 1 ? (options.partnerOrgId ?? null) : null;
    pendingRefresh = options.refreshPromise ?? null;
    state.isVisible = true;
  }

  async function awaitPendingRefresh() {
    if (!pendingRefresh) return;
    await pendingRefresh;
    pendingRefresh = null;
  }

  function closeModal() {
    state.isVisible = false;
    state.count = 0;
    state.partnerOrgId = null;
    pendingRefresh = null;
  }

  return {
    state: readonly(state),
    showOpenDataPartnersPreparing,
    awaitPendingRefresh,
    closeModal,
  };
}
